import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { selectColorList } from '../select-color-list';
import { IEnhanceSlider } from '../types';

const getFeature = () => {
    const { $t } = getLocaleStore();
    const feature: IEnhanceSlider[] = [
        {
            featureType: 'color',
            name: $t((v) => v.mainLayer.enhance.config.posterizeLight),
            keyName: 'posterize_light',
            maxVal: 100,
            minVal: 0,
            opacityOpposite: true,
            options: {
                blue: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                green: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                orange: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                purple: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                red: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                yellow: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
            },
        },
    ];
    return feature;
};

export const getSliderConfig = (theme = AppTheme.white) => {
    const list: Array<IEnhanceSlider[]> = [];

    selectColorList.forEach((color) => {
        const feature = getFeature().map((item) => {
            if (theme == 'dark') {
                item.background = {
                    useStyle: true,
                    classname: item.options?.[color.key].darkBackgroundClass,
                };
                item.wrapBackground = {
                    useStyle: true,
                    classname: item.options?.[color.key].darkWrapBackgroundClass,
                };
            } else {
                item.background = {
                    useStyle: true,
                    classname: item.options?.[color.key].lightBackgroundClass,
                };
                item.wrapBackground = {
                    useStyle: true,
                    classname: item.options?.[color.key].lightWrapBackgroundClass,
                };
            }
            return item;
        });
        list.push(feature);
    });

    return list;
};
